import * as React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';
import { Link, useParams } from 'react-router-dom';

import { useGetAllowList } from 'src/features/parkingManagement/api/AllowListAPI/useGetAllowList';
import DashboardGeneralBlock from 'src/features/parkingManagement/components/AllowLists/DashboardGeneralBlock';
import AllowListMembersTable from 'src/features/parkingManagement/components/AllowLists/table/AllowListMembersTable';
import {
    ALLOW_LIST_PURPOSE_TRANSLATION_MAP,
    allowListTypeBadgeOptions,
} from 'src/features/parkingManagement/types/allowList';
import { allowListMessages } from 'src/features/parkingManagement/utils/allowListMessages';
import { ICON_MAP } from 'src/features/parkingStatus/utils';
import { SectionBlock } from 'src/registry/components/blocks/SectionBlock';
import { Badge } from 'src/registry/ui/Badge';
import { Button } from 'src/registry/ui/Button';
import { useTitleStore } from 'src/stores/useTitleStore';
import { generalMessages } from 'src/utils/messages';

export default function AllowListDashboard() {
    const { formatMessage } = useIntl();
    const { parkingId = '', listId = '' } = useParams();

    const { setTitle, removeTitle } = useTitleStore();

    const { data: allowList } = useGetAllowList({ parkingId, listId });

    React.useEffect(() => {
        if (!allowList) return;
        setTitle(allowList.name);
        return () => removeTitle();
    }, [allowList, formatMessage]);

    const dashboardData = {
        section1: [
            { title: generalMessages.name, value: allowList?.name },
            {
                title: allowListMessages.type,
                value: allowList?.type ? (
                    <Badge theme={allowListTypeBadgeOptions[allowList.type].theme}>
                        <FontAwesomeIcon
                            icon={allowListTypeBadgeOptions[allowList.type].icon}
                            size={allowListTypeBadgeOptions[allowList.type].iconSize}
                        />
                        {formatMessage(allowListTypeBadgeOptions[allowList.type].label)}
                    </Badge>
                ) : (
                    '-'
                ),
            },
            {
                title: allowListMessages.purposes,
                value: allowList?.purposes
                    ? allowList.purposes
                          .map((purpose) => formatMessage(ALLOW_LIST_PURPOSE_TRANSLATION_MAP[purpose]))
                          .join(', ')
                    : '-',
            },
        ],
    };

    return (
        <>
            <Button asChild className="-mt-6 place-self-start p-0" variant="link">
                <Link to={`/parking-management/${parkingId}/allow-lists`}>
                    <FontAwesomeIcon icon={ICON_MAP.BACK} className="opacity-50" />
                    {formatMessage(allowListMessages.backToAllLists)}
                </Link>
            </Button>

            <div className="flex flex-col gap-4 sm:gap-6 md:flex-row">
                <SectionBlock>
                    <div className="flex w-full flex-col gap-2 lg:flex-row lg:items-stretch">
                        <DashboardGeneralBlock
                            dashboardData={dashboardData}
                            indexForLastSeparator={0}
                            className="flex-1 2xl:flex-2"
                        />
                    </div>
                    <AllowListMembersTable />
                </SectionBlock>
            </div>
        </>
    );
}
